if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

// Clarity fix (21 Oct 2026): product card sliders are only built when the card
// comes near the screen, instead of all at once on page load.
(function () {
	const dir = document.querySelector('html').getAttribute("dir");
	let nextEl = ".product-button-group .swiper-button-next";
	let prevEl = ".product-button-group .swiper-button-prev";
	if (dir === 'rtl') {
		[nextEl, prevEl] = [prevEl, nextEl];
	}

	const buildSlider = (slider) => {
		if (!slider || slider.swiper) return;
		new Swiper(slider, {
			pagination: {
				el: ".product-pagination .swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
			},
			allowTouchMove: true,
			990: {
				allowTouchMove: false,
			},
		});
	};

	const observer = ('IntersectionObserver' in window)
		? new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					buildSlider(entry.target);
				}
			});
		}, { rootMargin: '300px 0px' })
		: null;

	const initSlider = () => {
		document.querySelectorAll(".product-card-js").forEach((slider) => {
			if (slider.swiper) return;
			if (observer) {
				observer.observe(slider);
			} else {
				buildSlider(slider);
			}
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
